/**
 * @fileoverview Notes markdown normalisation.
 *
 * Split out of `NotesSection.tsx` (react-refresh/only-export-components).
 */

/** Convert inline bullet characters into markdown list items. */
export function normaliseForMarkdown(raw: string): string {
  return raw.replace(/\s*•\s*/g, "\n- ").trim();
}
